import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import { BlobServiceClient } from '@azure/storage-blob';
import { azureConfig } from 'helpers/azureConfig';
import 'react-toastify/dist/ReactToastify.css';
import { Container, Row, Col } from 'reactstrap';
import { loadCampEmailData as onGetTempById } from "../../store/templates/actions";
import { API_URL } from 'helpers/app_url';
const CampUnEditorNew = forwardRef(({ design }, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [selectImageCallback, setSelectImageCallback] = useState(null);
  const editorRef = useRef(null);
  const { templateId, campId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { campData, loading } = useSelector(state => ({
    campData: state.Template.campData,
    loading: state.Template.loading,
  }));

  useEffect(() => {
    
    dispatch(onGetTempById(campId));
  }, [dispatch, templateId]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://editor.unlayer.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.unlayer.init({
        id: 'editor',
        projectId: 228097,
        displayMode: 'email',
        user: {
          id: 1
        },
        features: {
          stockImages: {
            enabled: false,
          },
          textEditor: {
            tables: true
          },
          sendTestEmail: true
        }
      });

   
    };

    return () => {
      document.body.removeChild(script);
    };
  },[templateId]);

  useEffect(() => {
    if (campData && campData.emailCampaignFullContent) {
      const templateContent = campData.emailCampaignFullContent;
      const templateCss = campData.templateCSS;
      if (templateContent) {
        try {
        
          const parsedContent = JSON.parse(templateContent);
          //
          window.unlayer.loadDesign(parsedContent);
        } catch (error) {
          console.error('Error parsing template content:', error);
        }
      }
    }
  }, [campData]);



  const handleImageSelect = (src) => {
    if (selectImageCallback) {
      selectImageCallback({ url: src });
      setIsModalOpen(false);
    }
  };

  const exportHtml = (callback) => {
    if (window.unlayer) {
      window.unlayer.exportHtml((data) => {
        if (callback) {
          callback(data);
        }
      });
    }
  };
  useImperativeHandle(ref, () => ({
    exportHtml: (callback) => {
      if (window.unlayer) {
        window.unlayer.exportHtml((data) => {
          if (callback) {
            callback(data);
          }
        });
      }
    }
  }));
  const saveDesign = () => {
    try {
      if (window.unlayer && editorRef.current) {
        const designState = window.unlayer.saveDesign();
        return designState;
      }
      return null;
    } catch (error) {
      console.error('Error saving design:', error);
      return null;
    }
  };
  //
  return (
    <div>
        
      <div id="editor" style={{ height: '800px' }} />
   
    </div>
  );
});

CampUnEditorNew.displayName = 'LoadUnlayer';

CampUnEditorNew.propTypes = {
  design: PropTypes.shape({
    html: PropTypes.string.isRequired
  }),
};

export default CampUnEditorNew;



